export default "__VITE_ASSET__xM6y6gsr__"